import * as types from './logSourcesActionTypes';

export default (state = {}, action) => {
    switch(action.type) {
        case types.SORT_LOG_SOURCES:
            return action.sort;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/log-sources/sortLogSourcesReducer.js